import { useContext } from "react";

import { ProgressBar } from "../progress-bar";

import { MenuContext } from "./header-context";

export const HeaderSteps = () => {
  const context = useContext(MenuContext);

  return (
    <ProgressBar
      isOpen={!!context.stepsIsVisible}
      hideStepsMenu={context.showSteps}
    />
  );
};
